export const LAST_SEARCH_SERVICE = "LastSearchService";

export type CookieKey = "idAdvertise" | "car" | "bike";
